module.exports = __webpack_public_path__ + "img/wombat_wombatbridge.48d91ad.png";